import { useExportAllAgecStats } from "~/gen/api"
import { downloadFile } from "~/utils/downloadFile"

export const useExportAGECStatsMutation = () =>
  useExportAllAgecStats({
    mutation: {
      onSuccess(data) {
        downloadFile(
          data.data,
          `agec-stats_${new Date().toJSON().slice(0, 10)}.csv`,
          "text/csv"
        )
      },
    },
  })
